import { render } from "./SamplesReceived.vue?vue&type=template&id=8dafcd18"
import script from "./SamplesReceived.vue?vue&type=script&lang=js"
export * from "./SamplesReceived.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/SamplesReceived.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8dafcd18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8dafcd18', __exports__)) {
    console.log('reload')
    api.reload('8dafcd18', __exports__)
  }
  
  module.hot.accept("./SamplesReceived.vue?vue&type=template&id=8dafcd18", () => {
    console.log('re-render')
    api.rerender('8dafcd18', render)
  })

}


export default __exports__